import React, { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { DataGrid, GridToolbar,frFR  } from '@mui/x-data-grid';
import { useSelector ,useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";
import Cookies from 'js-cookie'

import Autorize from '../../ui/autorize';
import { getUserRule} from '../../../utils/userRule';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Lst_Membre_Annee({secteur,annee,reportname}) {

    const [listClub, setListClub] = useState([]);   
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");
  
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    useEffect(() => { 
                  
        
        const fetchData = async () => {
            try {

                let RuleReport = await getUserRule("read_reports",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));
                setAutorize(RuleReport);

            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
              }
        };
        fetchData(); // Appel de la fonction asynchrone
        

        if(autorize)
        {
            setListClub([]);
       
            console.log(process.env.REACT_APP_API + '/rapports/'+ reportname +'/'+ secteur + "/"+ annee);
            MyAxios.get(process.env.REACT_APP_API + '/rapports/'+ reportname +'/'+ secteur + "/"+ annee) //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                //console.log(res.data);
                setListClub(res.data);

/*
                {Object.entries(listClub).map(([key, value]) => (

                    value
                ))}*/
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               if(error.response.status === 401)// pas autorisé
               setErrorAxios(true);   

            });

        }


    },[secteur,reportname,autorize]);
   

    const navigate = useNavigate();       
    const dispatch = useDispatch();

    const onClicked = (value) => { 
        console.log("!*******:" + value);
        dispatch({ type: 'set' , payload:  value});
        sessionStorage.setItem('clubId',  value);
        sessionStorage.setItem('secteur',  secteur);
        navigate('/club',)
    };

    const columns = [                  
        {      field: 'id',      headerName: 'Club' ,    width: 130 ,    }  ,         
        {      field: 'octobre',     headerName: 'octobre' ,  width: 120 ,     }  ,
        {      field: 'novembre',     headerName: 'Novembre' ,  width: 120 ,     }  ,
        {      field: 'decembre',     headerName: 'Décembre' ,  width: 120 ,     }  ,
        {      field: 'janvier',     headerName: 'Janvier' ,  width: 120 ,     }  ,
        {      field: 'fevrier',     headerName: 'Février' ,  width: 120 ,     }  ,
        {      field: 'mars',     headerName: 'Mars' ,  width: 120 ,     }  ,
        {      field: 'avril',     headerName: 'Avril' ,  width: 120 ,     }  ,
        {      field: 'mai',     headerName: 'Mai' ,  width: 120 ,     }  ,
        {      field: 'juin',     headerName: 'Juin' ,  width: 120 ,     }  ,
        {      field: 'juillet',     headerName: 'Juillet' ,  width: 120 ,     }  ,
        {      field: 'aout',     headerName: 'Aout' ,  width: 120 ,     }  ,
        {      field: 'septembre',     headerName: 'Septembre' ,  width: 120 ,     }  ,
      
    ];

                  
        

        return (
                <div style={{ height: 600,maxWidth: 1700 }}>
                    <Autorize axiosError={errorAxios} />
                     


                    <DataGrid key="DataGridMember" localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                rows={listClub}
                                
                                columns={columns}
                                pageSize={25}
                                rowsPerPageOptions={[25]}
                                components={{ Toolbar: GridToolbar }} 
                                initialState={{
                                    filter: {
                                      filterModel: {
                                        items: [{ columnField: 'Status', operatorValue: 'equals', value: 'Actif' }],
                                      },
                                    },
                                  }}
                                
                            />






                   
                </div>
       
        );
   
};

export default Lst_Membre_Annee;